<script>
import { BaseResource as Resource } from '../defaults/resource'

export default {
  async fetch ({ route, redirect, error }) {
    const resource = Resource.query().where('url', route.path).first()

    if (!resource) {
      return error({ statusCode: 404, message: 'Die von Ihnen angefordertete Datei konnte leider nicht gefunden werden.' })
    }

    redirect(resource.columns.file.url)
  }
}
</script>
